import React from 'react'
import { Video } from '@shared/components/video'
import cn from 'classnames'

import { Back } from '../Back'

import styles from './styles.module.scss'

const ContractAndDeposit = () => {
	return (
		<article className={styles.article}>
			<Back />
			<h1 className={styles.heading}>Подписание документов и перевод денег</h1>

			<nav className={styles.nav}>
				<ul>
					<li className={styles.navItem}>
						<a className={styles.link} href='#documents'>
							Документы для подписания
						</a>
					</li>
					<li className={styles.navItem}>
						<a className={styles.link} href='#subscribe'>
							Процесс оформления
						</a>
					</li>
					<li className={styles.navItem}>
						<a className={styles.link} href='#transfer'>
							Перевод денег для сбережения
						</a>
					</li>
				</ul>
			</nav>
			<h3 id='documents' className={styles.title}>
				Документы для подписания
			</h3>
			<p className={cn(styles.paragraph, styles.paragraphBeforeList)}>
				Для размещения сбережений нужно предоставить минимальный пакет документов:
			</p>
			<ul className={styles.list}>
				<li className={styles.item}>— паспорт.</li>
				<li className={styles.item}>— СНИЛС.</li>
			</ul>

			<h3 id='subscribe' className={styles.title}>
				Процесс оформления
			</h3>
			<p className={cn(styles.paragraph, styles.paragraphBeforeList)}>
				Подписание документов для размещения сбережений происходит полностью в удалённом формате.
				Процесс оформления сделки состоит из нескольких шагов:
			</p>

			<ul>
				<li>
					<p className={styles.paragraph}>
						<b>Шаг 1.</b> Регистрируетесь в личном кабинете инвестора на сайте или в приложении.
					</p>
				</li>
				<li>
					<p className={styles.paragraph}>
						<b>Шаг 2.</b> Загружаете в личном кабинете фото паспорта и СНИЛС.
					</p>
				</li>
				<li>
					<p className={styles.paragraph}>
						<b>Шаг 3.</b> Кликаете на «Начать инвестировать» и выбираете сумму, срок и тип выплаты
						процентов.
					</p>
				</li>
				<li>
					<p className={styles.paragraph}>
						<b>Шаг 4.</b> Проходите идентификацию в формате видеозвонка через WhatsApp, Skype или
						Zoom. Нужно будет ответить на простые вопросы. К примеру, назвать ФИО или подтвердить
						сумму сбережения. Процесс занимает около 15 минут.
					</p>
				</li>
				<li>
					<p className={styles.paragraph}>
						<b>Шаг 5.</b> Подписываете документы электронной подписью и подтверждаете её кодом из
						СМС. Посмотрите ролик, чтобы узнать подробности об электронной подписи:
						{/* Как работает ПЭП — простая электронная подпись */}
						<Video poster='/images/how-sign-work.jpg' src='/videos/how-sign-work.mp4' />
					</p>
				</li>
				<li>
					<p className={styles.paragraph}>
						<b>Шаг 6.</b> Переводите сбережения по реквизитам на счёт КПК «Фонд Ипотечного
						Кредитования».
					</p>
				</li>
			</ul>

			<h3 id='transfer' className={styles.title}>
				Перевод денег для сбережения
			</h3>
			<p className={styles.paragraph}>
				Перевести деньги для сбережения можно по реквизитам на счёт КПК «Фонд Ипотечного
				Кредитования». Чтобы заполнить реквизиты автоматически, можно отсканировать QR-код в
				банковском приложении. Найти его можно в личном кабинете заёмщика в разделе «Главная».
			</p>
		</article>
	)
}

export default ContractAndDeposit
